import { render, staticRenderFns } from "./Optimization.vue?vue&type=template&id=8fbef582&lang=pug&"
import script from "./Optimization.vue?vue&type=script&lang=ts&"
export * from "./Optimization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports